export default __webpack_public_path__ + "static/media/SaranshDabas_USC.dcd9ab80.pdf";